import React from "react";
import classes from './privacyPolicy.module.css';

const PrivacyPolicy = () => {
    return (
        <div className={classes.Container}>
            <h2>1.Terms</h2>
            <h3>1.1 What these terms cover</h3>
            <p>These are the terms and conditions (“Terms”) on which 6 Yard supplies the Entry to  the Entrants. By submitting an Order to register an Entrant at a 6 Yard Programme, you agree to these terms  personally and on behalf of the Entrant you enroll. By submitting an Order, you confirm that you are at least 18  years of age or are the parent or legal guardian of the Entrant and that the details of your legal relationship with  the Entrant as specified in the Entrant Order are true and accurate</p>
            <h3>1.2  Why you should read them</h3>
            <p>Please read these Terms carefully before you submit your Order to us and print a  copy for future reference. These Terms tell you who we are, how we will provide the Entry to you, how you  and we may change or end the Contract, what to do if there is a problem and other important information. We  intend to rely on these Terms and your Order. If you think that there is a mistake in these Terms or require any  changes, please contact us to discuss</p>
            <h2>2. About us & how to contact us</h2>
            <h3>2.1  Who we are</h3>
            <p>We are 6 Yard, a limited liability company incorporated and registered in Jordan with company  number 43557. We are registered for VAT</p>
            <h3>2.2  How to contact us</h3>
            <p>We are 6 Yard, a limited liability company incorporated and registered in Jordan with company  number 43557. We are registered for VAT</p>
            <h3>2.3  How we may contact you</h3>
            <p>If we have to contact you, we will do so by telephone or by writing to you at the  email address or WhatsApp, you provided to us in your Order</p>
            <h2>3. Eligibility </h2>
            <h3>3.1  Age</h3>
            <p>Unless otherwise specified, the Programme is open to any person aged 2 and above</p>
            <h3>3.2  Physical state</h3>
            <p>The Entrant is physically fit and able to participate in the activities involved in the Programme</p>
        </div>
    )
}

export default PrivacyPolicy;